import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Divider } from '@dealstack/frontend/shared/components/fundament/Divider/Divider';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const Dashboard = ({ className }: Props) => {
	return (
		<div className={className}>
			<LinkWrapper>
				<Link to={GODMODE_ROOT_ROUTES.MANAGE_USER}>
					<Button variant="primary">Manage User</Button>
				</Link>
				<Link to={GODMODE_ROOT_ROUTES.MANAGE_MIP}>
					<Button variant="primary">Manage MIP</Button>
				</Link>
				<Link to={GODMODE_ROOT_ROUTES.MANAGE_FILES}>
					<Button variant="primary">Files</Button>
				</Link>
				<Link to={GODMODE_ROOT_ROUTES.MANAGE_PRE_FILLABLE_FORMS}>
					<Button variant="primary">Manage pre-fillable forms</Button>
				</Link>
				<Link to={GODMODE_ROOT_ROUTES.MANAGE_GENERATABLE_DOCUMENTS}>
					<Button variant="primary">Manage generatable documents</Button>
				</Link>
			</LinkWrapper>
			<Divider />
		</div>
	);
};

const LinkWrapper = styled.div`
	display: flex;
	gap: 1em;
`;

const Memoized = memo(Dashboard);
const Styled = styled(Memoized)`
	padding: 2rem;

	${Divider} {
		margin-top: 2rem;
		margin-bottom: 2rem;
	}
`;

export { Styled as Dashboard };
